import { render } from "./Footer.vue?vue&type=template&id=381daae0&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=381daae0&lang=scss&scoped=true"

import exportComponent from "D:\\Development\\JS\\SeptaCode\\septacode.com\\demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381daae0"]])

export default __exports__